export default Object.freeze({
  guideRuns: '17000+',
  guideRunsNumber: '17000',
  reviews: '2000+',
  systems: '2800+',
  visitorsMonth: '16000+',
  visitorsYear: '120 000+',
  markets: '5',
});
